export class MockLoginPostRequest {
  emailAddress: string
  password: string

  constructor(email: string, pass: string) { this.emailAddress = email; this.password = pass }
}

export class MockLoginPostResponse {
  emailAddress: string
  failedMessage?: string
  constructor(emailAddress: string) { this.emailAddress = emailAddress }
}
